const KEY = 'skillsSurveyPendingVerify';

export const getPendingVerify = (): string => {
  return localStorage.getItem(KEY) || '';
};

export const setPendingVerify = (token: unknown): void => {
  if (typeof token === 'string' && token.length > 0) {
    localStorage.setItem(KEY, token);
  }
};

export const clearPendingVerify = (): void => {
  localStorage.removeItem(KEY);
};
